import Alpine from "alpinejs";
import {
  AccordionToggleNext,
  SlideToggleNext,
  SlideToggleBinders,
} from "../modules/SlideToggle";
import { TextContentProcessor } from "../modules/TextContentProcessor";

Alpine.store("menuOpen", false);

Alpine.bind("textContent", TextContentProcessor);
Alpine.bind(SlideToggleBinders.accordionTrigger, AccordionToggleNext);
Alpine.bind(SlideToggleBinders.slideTrigger, SlideToggleNext);

Alpine.start();
